// Placeholder id for a language that has no saved translation row yet. It must
// be derived from the item + language, never from the clock: effects keyed on
// the id re-run whenever its value changes, and a churning id reloads the
// editor from the server row, wiping unsaved local content.
export const fallbackTranslationId = (itemId: string, language: string) =>
	`temp-${itemId}-${language}`
